export default __webpack_public_path__ + "static/media/LogOut.83e8d61c.svg";